import { GPUAPIObject } from './GPUAPIObject'
import { GPUTexture2D } from './GPUTexture'
import * as GL from './webgl2constants'

enum CubemapDir {
	X = "X", // positive
	Y = "Y", // positive
	Z = "Z", // positive
	x = "x", // negative
	y = "y", // negative
	z = "z", // negative
}

type Attachment = 0|1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|"d"|"s"|"ds"

export class GPUFBO extends GPUAPIObject<WebGLFramebuffer> {

	get target(): GLenum { return GL.FRAMEBUFFER } // GL.READ_FRAMEBUFFER | GL.DRAW_FRAMEBUFFER
	get targetBinding(): GLenum { return GL.FRAMEBUFFER_BINDING } // GL.READ_FRAMEBUFFER_BINDING | GL.DRAW_FRAMEBUFFER_BINDING

	createFunction(): WebGLFramebuffer | null { return this.gl.createFramebuffer() }
	deleteFunction(): void { this.gl.deleteFramebuffer(this.obj) }
	bind(): () => void {
		let gBefore = this.gl.getParameter(this.targetBinding)
		this.gl.bindFramebuffer(this.target, this.obj)
		return () => this.gl.bindFramebuffer(this.target, gBefore)
	}

	attachmentList: Array<GLenum> = []

	attachTex2d(attachment: Attachment, tex: GPUTexture2D, dir?: CubemapDir) { // GPUTextureCubemap should be supported as well
		let target = tex.target
		// TODO if( target = cubemap ) {
		// 	switch(dir) {
		// 		case CubemapDir.X: target = GL.TEXTURE_CUBE_MAP_POSITIVE_X; break
		// 		case CubemapDir.Y: target = GL.TEXTURE_CUBE_MAP_POSITIVE_Y; break
		// 		case CubemapDir.Z: target = GL.TEXTURE_CUBE_MAP_POSITIVE_Z; break
		// 		case CubemapDir.x: target = GL.TEXTURE_CUBE_MAP_NEGATIVE_X; break
		// 		case CubemapDir.y: target = GL.TEXTURE_CUBE_MAP_NEGATIVE_Y; break
		// 		case CubemapDir.z: target = GL.TEXTURE_CUBE_MAP_NEGATIVE_Z; break
		// 		default: throw "must specify direction"
		// 	}
		// }

		let a: GLenum
		switch(attachment) {
			case "d":  a = GL.DEPTH_ATTACHMENT;break
			case "s":  a = GL.STENCIL_ATTACHMENT;break
			case "ds": a = GL.DEPTH_STENCIL_ATTACHMENT;break
			default: 
				if( typeof attachment == "number" && attachment<16 && -1 < attachment ) {
					a = GL.COLOR_ATTACHMENT0 + attachment
				} else {
					throw `attachment must be 0,...,15 or "d" or "s" or "ds"`
				}
		}
		// TODO : unattach : filter out in attachmentList and other stuff
		this.attachmentList.push(a)
		this.use(()=>{
			this.gl.framebufferTexture2D(this.target, a, target, tex.tex, 0)
			this.gl.drawBuffers(this.attachmentList)
		})
	}

// void framebufferRenderbuffer(enum target, enum attachment, enum renderbuffertarget, WebGLRenderbuffer renderbuffer);
// 	target: FRAMEBUFFER
// 	attachment: COLOR_ATTACHMENT0, COLOR_ATTACHMENTn (n ∈ 1...15), { DEPTH, STENCIL, DEPTH_STENCIL }_ATTACHMENT
// 	renderbuffertarget: RENDERBUFFER

// any getFramebufferAttachmentParameter(enum target, enum attachment, enum pname)
// 	target and attachment: Same as for framebufferRenderbuffer
// 	pname: FRAMEBUFFER_ATTACHMENT_OBJECT_{ TYPE, NAME }, FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL, FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE,
// 		FRAMEBUFFER_ATTACHMENT_{ ALPHA, BLUE, GREEN, RED } _SIZE, FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING, FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE,
// 		FRAMEBUFFER_ATTACHMENT_{ DEPTH, STENCIL } _SIZE, FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER

// void blitFramebuffer(int srcX0, int srcY0, int srcX1, int srcY1, int dstX0, int dstY0, int dstX1, int dstY1, bitfield mask, enum filter)

// void framebufferTextureLayer(enum target, enum attachment, WebGLTexture ? texture, int level, int layer)

// void invalidateFramebuffer(enum target, sequence <enum> attachments)

// void invalidateSubFramebuffer(enum target, sequence <enum> attachments, int x, int y, sizei width, sizei height)

// void readBuffer(enum src)

}

export class GPURenderBuffer extends GPUAPIObject<WebGLRenderbuffer> {
	protected createFunction(): WebGLRenderbuffer | null { return this.gl.createRenderbuffer() }
	protected deleteFunction(): void { this.gl.deleteRenderbuffer(this.obj) }
	bind(): () => void {
		let gBefore = this.gl.getParameter(GL.RENDERBUFFER_BINDING)
		this.gl.bindRenderbuffer(GL.RENDERBUFFER, this.obj)
		return () => this.gl.bindRenderbuffer(GL.RENDERBUFFER, gBefore)
	}

	// any getRenderbufferParameter(enum target, enum pname)
	// 	target: RENDERBUFFER
	// 	pname: RENDERBUFFER_{ WIDTH, HEIGHT, INTERNAL_FORMAT }, RENDEDRBUFFER_{ RED, GREEN, BLUE, ALPHA, DEPTH } _SIZE, RENDERBUFFER_STENCIL_SIZE, RENDERBUFFER_SAMPLES

	// any getInternalformatParameter(enum target, enum internalformat, enum pname)
	// 	pname: SAMPLES

	// void renderbufferStorage(enum target, enum internalformat, sizei width, sizei height)
	// 	target: RENDERBUFFER
	// 	internalformat: Accepts internal formats from OpenGL ES 3.0, as well as DEPTH_STENCIL

	// void renderbufferStorageMultisample(enum target, sizei samples, enum internalformat, sizei width, sizei height)
}